__turbopack_context__.v({
  "closeIcon": "Modal-module-scss-module__vzGZ_q__closeIcon",
  "content": "Modal-module-scss-module__vzGZ_q__content",
  "footer": "Modal-module-scss-module__vzGZ_q__footer",
  "large": "Modal-module-scss-module__vzGZ_q__large",
  "medium": "Modal-module-scss-module__vzGZ_q__medium",
  "modal": "Modal-module-scss-module__vzGZ_q__modal",
  "small": "Modal-module-scss-module__vzGZ_q__small",
});
